// import "./wdyr";
import { ReactElement } from "react";
import { AppRegistry, Platform } from "react-native";
import App from "./App";
import { name as appName } from "./app.json";
import { tCheckoutError } from "./util/types";

declare global {
  interface Window {
    fbq: unknown;
    checkoutConfig: {
      checkoutId: string;
      containerId: string;
    };
    blnceCheckout: {
      create: (params: {
        checkoutTokens: Array<string>;
        url: string;
        type: string;
        hideBackOnFirstScreen: boolean;
        logoURL: string;
        isAuth: boolean;
        onSuccess?: () => void;
        onComplete: () => void;
        onError: (error: tCheckoutError) => void;
        callback: (error: Error, msg: string) => void;
        onClose: () => void;
      }) => {
        render: (param: string) => void;
      };
      destroy: () => void;
    };
  }
}

export const LaunchApp = (): ReactElement => {
  return <App />;
};

AppRegistry.registerComponent(appName, () => LaunchApp);
if (Platform.OS === "web") {
  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById("root"),
  });
}
// /**
//  * @format
//  */
//
// import { AppRegistry } from "react-native";
// import App from "./src/App";
// import { name as appName } from "./app.json";
//
// AppRegistry.registerComponent(appName, () => App);
